import  { useState, useEffect } from 'react';
import { Table, Tabs, Button, Row, Col } from 'antd';
import { EyeFilled, EditFilled, PlusOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { useLocation, useNavigate } from 'react-router-dom';
import henceforthApi from '../utils/henceforthApi';


const RaceTable = () => {
  const [state, setState] = useState({ data: [], count: 0 });
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('PUBLIC');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const navigate = useNavigate();

  const raceStat = {
    ACTIVE: 'Active',
    SCHEDULED: 'Scheduled',
    COMPLETED: 'Completed',
    CANCELLED: 'Cancelled',
  };

  const handlePagination = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const onChange = (value) => {
    setActiveTab(value);
    setCurrentPage(1); // reset pagination on tab change
  };

  const handleView = (id) => navigate(`/race/${id}/view`);
  const handleEdit = (id) => navigate(`/race/${id}/edit?race_type=${activeTab}`);

  const columns = [
    {
      title: 'Sr. no.',
      dataIndex: 'sr_no',
      key: 'sr_no',
      render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Distance',
      dataIndex: 'total_distance',
      key: 'total_distance',
      render: (_, data) =>
        data?.total_distance ? `${(data.total_distance / 1000).toFixed(2)} kms` : 'N/A',
    },
    {
      title: 'Participants',
      dataIndex: 'max_participants',
      key: 'max_participants',
      render: (_, data) => `${data?.active_participants || 0}/${data?.max_participants || 0}`,
    },
    {
      title: 'Started on',
      dataIndex: 'start_time',
      key: 'start_time',
      render: (_, data) => {
        const time = data?.start_time || data?.scheduled_time;
        return time ? dayjs(time).format('DD MMM YYYY hh:mm a') : 'N/A';
      },
    },
    {
      title: 'Race status',
      dataIndex: 'race_status',
      key: 'race_status',
      render: (_, data) => raceStat[data?.race_status] || 'Scheduled',
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, data) => (
        <div className="d-flex gap-2">
          <Button
            type="default"
            shape="circle"
            onClick={() => handleView(data._id)}
            className="bg-black text-white hover:bg-[#1a1a1a] border-none"
          >
            <EyeFilled 
            />
          </Button>
          {(activeTab === 'MARATHON' || activeTab === 'QUICK_ADMIN') && (
            <Button
              type="default"
              shape="circle"
              onClick={() => handleEdit(data._id)}
              className="bg-black text-white hover:bg-[#1a1a1a] border-none"
            >
              <EditFilled />
            </Button>
          )}
        </div>
      ),
    },
  ];

  const TableData = () => (
    <Row gutter={[20, 20]}>
      <Col span={24}>
        <div className="flex justify-end mb-2">
          {(activeTab === 'MARATHON' || activeTab === 'QUICK_ADMIN') && (
            <Button
              type="default"
              icon={<PlusOutlined />}
              onClick={() => navigate(`/race/add?race_type=${activeTab}`)}
              className="bg-black  text-white hover:bg-[#1a1a1a] border-none"
            >
              Add Race
            </Button>
          )}
        </div>
        <Table
          dataSource={state?.data || []}
          columns={columns}
          pagination={
            state.count > pageSize
              ? {
                  current: currentPage,
                  pageSize: pageSize,
                  total: state.count,
                  onChange: handlePagination,
                  showSizeChanger: false,
                }
              : false
          }
          scroll={{ x: '100%' }}
          loading={loading}
          rowKey="_id"
        />
      </Col>
    </Row>
  );

  const items = [
    { key: 'PUBLIC', label: 'Public', children: <TableData /> },
    { key: 'PRIVATE', label: 'Private', children: <TableData /> },
    // { key: 'MARATHON', label: 'Marathon', children: <TableData /> },
    { key: 'SOLO', label: 'Solo', children: <TableData /> },
    { key: 'QUICK_ADMIN', label: 'Quick', children: <TableData /> },
  ];

  const initializeData = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams();
      params.set('race_type', activeTab||"PUBLIC");
      params.set('pagination', (currentPage - 1).toString());
      params.set('limit', pageSize.toString());

      const apiRes = await henceforthApi.Race.listing(params.toString());
      setState({
        data: apiRes?.data?.races || [],
        count: apiRes?.count || 0,
      });
    } catch (error) {
      console.error('Error fetching race data:', error);
    } finally {
      setLoading(false);
    }
  };
const location = useLocation();
  useEffect(() => {
    initializeData();
  }, [activeTab, currentPage, pageSize,location.search]);

  return (
    <div className="tabs-wrapper">
      <Tabs activeKey={activeTab} items={items} onChange={onChange} />
    </div>
  );
};

export default RaceTable;
